import api from "./api";

export const fetchOrders = async () => {
  try {
    const res = await api.get("/orders");
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch orders"
    );
  }
};

export const createOrder = async (orderData) => {
  try {
    const res = await api.post("/orders", orderData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create order"
    );
  }
};
